/** Ant Design theme tokens aligned with HRZyra sidebar teal (--sidebar-primary). */
export const HRZYRA_ANTD_THEME = {
    token: {
        colorPrimary: '#04B7B1',
        colorPrimaryHover: '#039E99',
        colorPrimaryActive: '#028580',
    },
};

/** Shared chip styles for permission screens (teal, not default antd blue/amber). */
export const PERMISSION_CHIP = {
    partial:
        'shrink-0 text-[10px] uppercase tracking-wide rounded-full px-2 py-0.5 font-semibold bg-sidebar-primary/15 text-sidebar-primary border border-sidebar-primary/30',
    essential:
        'shrink-0 text-[10px] uppercase tracking-wide rounded-full px-2 py-0.5 font-medium bg-sidebar-primary/10 text-sidebar-primary border border-sidebar-primary/20',
};
